import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Reflect01 = function Reflect01(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: 0.01,
      d: "M3 14.1378c0 .4696 0 .7044.0967.827a.45.45 0 0 0 .3478.1713c.1561.0019.3422-.1413.7145-.4276l3.9491-3.0378c.2524-.1942.3787-.2913.424-.4096a.4502.4502 0 0 0 0-.3222c-.0453-.1183-.1715-.2154-.424-.4096L4.159 7.4915c-.3723-.2863-.5584-.4295-.7145-.4276a.45.45 0 0 0-.3478.1713C3 7.3578 3 7.5926 3 8.0622v6.0756Zm18 0c0 .4696 0 .7044-.0967.827a.45.45 0 0 1-.3478.1713c-.1561.0019-.3422-.1413-.7145-.4276l-3.9491-3.0378c-.2524-.1942-.3787-.2913-.424-.4096a.4497.4497 0 0 1 0-.3222c.0453-.1183.1716-.2154.424-.4096l3.9491-3.0378c.3723-.2863.5584-.4295.7145-.4276a.45.45 0 0 1 .3478.1713c.0967.1226.0967.3574.0967.827v6.0756Z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 3v2.7m0 4.05v2.7m0 4.05v2.7M4.159 7.4915l3.9491 3.0378c.2524.1942.3787.2913.424.4096a.4502.4502 0 0 1 0 .3222c-.0453.1183-.1715.2154-.424.4096L4.159 14.7085c-.3723.2863-.5584.4295-.7145.4276a.45.45 0 0 1-.3478-.1713C3 14.8422 3 14.6074 3 14.1378V8.0622c0-.4696 0-.7045.0967-.827a.45.45 0 0 1 .3478-.1713c.1561-.0019.3422.1413.7145.4276Zm15.682 0-3.9491 3.0378c-.2524.1942-.3787.2913-.424.4096a.4497.4497 0 0 0 0 .3222c.0453.1183.1716.2154.424.4096l3.9491 3.0378c.3723.2863.5584.4295.7145.4276a.45.45 0 0 0 .3478-.1713c.0967-.1226.0967-.3574.0967-.827V8.0622c0-.4696 0-.7045-.0967-.827a.45.45 0 0 0-.3478-.1713c-.1561-.0019-.3422.1413-.7145.4276Z"
    })]
  }));
};
export default Reflect01;